import { Navigate, Outlet, useLocation } from "react-router-dom";
import ErrorPage from "./Pages/ErrorPage";
import { userDetails, selectedPartnerDetails } from "./Services/authenticationService";
import { slugifyTransform } from "./Utils/Helpers";

const ALLOWED_PARTNERS = userDetails()?.partnerDetails?.map((item)=>slugifyTransform(item.name));

const PartnerGuard = () => {
  const location = useLocation();

  const token = localStorage.getItem("loginDetails");
  const partner = slugifyTransform(selectedPartnerDetails()?.name);
console.log('location:::',location)
  // 1. Not logged in
  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // 2. Invalid partner
  if (!partner || !ALLOWED_PARTNERS.includes(partner)) {
    return <Navigate to={partner + "/page-not-found"} replace />;
  }

  // 3. Already correct route → render child routes
  if (location.pathname.startsWith(`/${partner}/`)) {
    return <Outlet />;
  }

  // 4. Fix wrong path → redirect properly
  return <Navigate to={`/${partner+location.pathname+location.search}`} replace />;
};

export default PartnerGuard;